import script from "./TurmaCombobox.vue?vue&type=script&setup=true&lang=js"
export * from "./TurmaCombobox.vue?vue&type=script&setup=true&lang=js"

import "./TurmaCombobox.vue?vue&type=style&index=0&id=82c8559c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82c8559c"]])

export default __exports__